(function () {
  document.documentElement.classList.add('nota-js');

  function revealOnScroll() {
    var elements = document.querySelectorAll('.nota-reveal');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function heroDepth() {
    var hero = document.querySelector('#MainContent > .shopify-section:first-child .hero');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.addEventListener(
      'scroll',
      function () {
        var offset = Math.min(window.scrollY * 0.08, 34);
        hero.style.setProperty('--nota-hero-offset', offset + 'px');
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      revealOnScroll();
      heroDepth();
    });
  } else {
    revealOnScroll();
    heroDepth();
  }
})();
